import { gql } from '@apollo/client';

export const SELECT_AUDIT_DECISION = gql`
  mutation SelectAuditDecision($input: SelectAuditDecisionInput!) {
    selectAuditDecision(input: $input) {
      auditItem {
        id
        type
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
        auditSessionId
        status
        position
        contentSnapshot {
          audioFileUrl
          transcription
          language
          topic
          contentType
          classificationType
          classificationResults {
            name
            severity
          }
          metadata
          triggeredPolicies {
            id
            name
            communityId
            description
            isEnabled
            labels {
              labelId
              severity
            }
            createdAt
            createdBy
            lastModifiedAt
            lastModifiedBy
          }
          nonTriggeredPolicies {
            id
            name
            communityId
            description
            isEnabled
            labels {
              labelId
              severity
            }
            createdAt
            createdBy
            lastModifiedAt
            lastModifiedBy
          }
          slmModelVersion
          slmPromptVersion
          quicktxtModelVersion
        }
        kustoReference {
          communityId
          subjectId
          timestamp
        }
        decisions {
          id
          auditItemId
          auditSessionId
          auditorId
          auditorName
          timestamp
          updatedAt
          isSelected
          selectedBy
          selectedAt
          languageCorrect
          transcriptionCorrect
          correctedTranscription
          originalLabels {
            name
            severity
          }
          correctedLabels {
            name
            severity
          }
          comments
        }
        decisionsCount
        selectedDecisionId
      }
    }
  }
`;
